var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',[_c('van-icon',{attrs:{"slot":"left","name":"arrow-left","color":"#000","size":".46rem"},on:{"click":_vm.back},slot:"left"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }